import React, { Fragment, Component }  from 'react';
import { connect } from 'react-redux';
import {
    downloadReport
} from '../actions/reportActions';


class ReportDownload extends Component {

    render() {
        return (
            <Fragment>
            </Fragment>
        );
    }

    componentDidMount(){
        const { reportId, institutionId, reportName, downloadReport } = this.props;
        downloadReport(reportId, institutionId, reportName);
    }
}
export default connect(
    (state, props) => {
        const { query } = props.location;
        const institutionId = query.containerId;
        const reportId = query.reportId;
        const reportName = query.reportName;

        return {
            institutionId,
            reportId,
            reportName,
        };
    },
    {
        downloadReport
    },
)(ReportDownload);
